var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBarChartTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5475 17.0006H7.26179V5.8577C7.26179 5.77913 7.1975 5.71484 7.11893 5.71484H6.11893C6.04036 5.71484 5.97607 5.77913 5.97607 5.8577V18.1434C5.97607 18.222 6.04036 18.2863 6.11893 18.2863H19.5475C19.6261 18.2863 19.6904 18.222 19.6904 18.1434V17.1434C19.6904 17.0648 19.6261 17.0006 19.5475 17.0006ZM8.83322 15.572H9.83322C9.91179 15.572 9.97608 15.5077 9.97608 15.4291V12.8577C9.97608 12.7791 9.91179 12.7148 9.83322 12.7148H8.83322C8.75465 12.7148 8.69036 12.7791 8.69036 12.8577V15.4291C8.69036 15.5077 8.75465 15.572 8.83322 15.572ZM11.5475 15.572H12.5475C12.6261 15.572 12.6904 15.5077 12.6904 15.4291V9.71484C12.6904 9.63627 12.6261 9.57199 12.5475 9.57199H11.5475C11.4689 9.57199 11.4046 9.63627 11.4046 9.71484V15.4291C11.4046 15.5077 11.4689 15.572 11.5475 15.572ZM14.2618 15.572H15.2618C15.3404 15.572 15.4046 15.5077 15.4046 15.4291V11.1077C15.4046 11.0291 15.3404 10.9648 15.2618 10.9648H14.2618C14.1832 10.9648 14.1189 11.0291 14.1189 11.1077V15.4291C14.1189 15.5077 14.1832 15.572 14.2618 15.572ZM16.9761 15.572H17.9761C18.0546 15.572 18.1189 15.5077 18.1189 15.4291V8.28627C18.1189 8.2077 18.0546 8.14341 17.9761 8.14341H16.9761C16.8975 8.14341 16.8332 8.2077 16.8332 8.28627V15.4291C16.8332 15.5077 16.8975 15.572 16.9761 15.572Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartTile);
export default ForwardRef;